import classNames from 'classnames/bind';
import React from 'react';
import { RiSave3Line } from 'react-icons/ri';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import styles from './index.module.scss';

import SelectProjectModal from '@/components/modals/SelectProject';
import { getCommandForSurveySegment } from '@/helpers/CommandConverter';
import { updateMission } from '@/helpers/Requester';
import { modalManager } from '@/libs/ModalContainer';
import { NotifierService as notifier } from '@/libs/Notifier';

const cx = classNames.bind(styles);

const SaveTool = () => {
  const params = useParams();
  const specs = useSelector((state) => state.mission.json.specs);
  const commands = useSelector((state) => state.mission.json.commands);
  const fences = useSelector((state) => state.mission.json.fences);
  const missionName = useSelector((state) => state.mission.name);

  const validAll = () => {
    if (commands.length === 0) {
      notifier.error('No mission defined.');
      return false;
    }
    if (!commands.some((command) => command.type === 'navWaypoint')) {
      notifier.error('Please add at least one waypoint.');
      return false;
    }
    if (!validWithJumpToItem()) {
      notifier.error("Please check the item number in the 'Jump To Item'.");
      return false;
    }
    return true;
  };

  const validWithJumpToItem = () => {
    if (!commands.some(({ type }) => type === 'doJump')) return true;

    let jumpToItemNumber = 1;
    let commandCount = 0;

    commands.forEach((command) => {
      switch (command.type) {
        case 'doJump':
          jumpToItemNumber = Math.max(jumpToItemNumber, command.data.item);
          break;

        case 'navLand':
          // Parachute 항목 체크한 경우
          if (command.data.parachute) {
            commandCount += 3; // Waypoint, Parachute Enable, Release 반영
          }
          break;

        case 'navWaypoint':
          // Speed 항목 체크한 경우
          if (command.data.speed) {
            commandCount++; // Change Speed 반영
          }
          break;

        case 'cusSurvey':
          {
            const surveyCommand = getCommandForSurveySegment(command);
            commandCount += surveyCommand.data.positions.length - 1;
          }
          break;

        default:
          break;
      }

      commandCount++;
    });

    return jumpToItemNumber <= commandCount;
  };

  const doSave = () => {
    if (!validAll()) return;

    if (params.id === 'new') {
      modalManager.show(SelectProjectModal);
      return;
    }

    updateMission(params.id, missionName, { specs, commands, fences }).then(({ success }) => {
      if (success) {
        notifier.success('The mission has been saved.');
      }
    });
  };

  const doSaveAs = () => {
    if (!validAll()) return;

    modalManager.show(SelectProjectModal);
  };

  return (
    <div className={cx('container')}>
      <div className={cx('button')} onClick={doSave}>
        <RiSave3Line size={20} color="white" />
      </div>
      <div className={cx('button')} onClick={doSaveAs}>
        <RiSave3Line size={20} color="white" />
        <span className={cx('as')}>As</span>
      </div>
    </div>
  );
};

export default SaveTool;
